import * as React from 'react';
import cn from '~modules/cn';
import './inline-loader.scss';

export type InlineLoaderColor = 'info' | 'success' | 'white' | 'gray' | 'silver' | 'orange' | 'multipass' | 'primary';

interface InlineLoaderProps {
    color?: InlineLoaderColor;
    className?: string;
    small?: boolean;
    mid?: boolean;
    setRef?: React.RefObject<HTMLElement> | { (e: HTMLElement | null): void };
    Tag?: 'div' | 'span';
    dataTestId?: string;
}

const InlineLoader = ({ color = 'info', dataTestId, className, small, mid, setRef, Tag = 'div' }: InlineLoaderProps): JSX.Element => (
    <Tag
        ref={setRef as $TSFixMe}
        className={cn('loader-ellipsis-container', className, `loader-${color}`, {
            'loader-ellipsis-container--small': small,
            'loader-ellipsis-container--mid': mid
        })}
        data-testid={dataTestId}
    >
        <Tag className="loader-ellipsis loader-ellipsis-1" />
        <Tag className="loader-ellipsis loader-ellipsis-2" />
        <Tag className="loader-ellipsis loader-ellipsis-3" />
        {/* Safari doesn't like animating before & after */}
    </Tag>
);

export default InlineLoader;
